<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.xsOnly" scrollable v-model="dialogHelp" width="600">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>help</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar flat>
        <v-btn @click="showMenu()" icon v-show="!menu">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-toolbar-title>Help</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="dialogHelp=false" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-0">
        <v-list class="py-0" v-show="menu">
          <v-list-tile @click="showChapter(0)" avatar>
            <v-list-tile-avatar>
              <v-icon>description</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>Introduction</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="showChapter(1)" avatar>
            <v-list-tile-avatar>
              <v-icon>description</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>VSC setup</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <div class="pa-3" v-show="!menu">
          <div v-show="chapters[0]">
            <p>EUHFORIA consists of two essential building-blocks: the coronal model and the heliosphere model. The two are ran separately.</p>
            <p>A heliosphere model run consists of three simulation phases:</p>
            <ol>
              <li>Relaxation of the ambient solar wind</li>
              <li>Insertion of CMEs</li>
              <li>Forecast</li>
            </ol>
            <span class="title">Relaxation</span>
            <p>Each model run starts by creating a steady-state (when in a frame co-rotating with the Sun) solar wind solution. This is accomplished by running the model for a set number of days starting from an initial state which is not a steady-state solution of the model equations. During this relaxation, any transient behaviour is transported out of the computational domain by the solar wind.</p>
            <span class="title">CME insertion</span>
            <p>At any given time, at least several CMEs are present in the inner heliosphere on average. The plasma environment in the interplanetary space is significantly modified by the presence of the CMEs, and this needs to be taken into account when modeling the evolution of a particular eruption.</p>
            <p>To accomplish this, after a steady-state solution has been obtained, a phase of inserting CMEs follows in the modeling pipelone. During this time, which is detected automatically, any CMEs prior to the start of the forecast are inserted.</p>
            <span class="title">Forecast</span>
            <p>The last phase of the run is the actual forecast, the time of start of which is equal to the observation time of the magnetogram. The forecast is reasonable to run forward in time approximately up until the East limb observation crosses the central meridian.</p>
          </div>
          <div v-show="chapters[1]">
            <p>In order to execute EUHFORIA on your own VSC account and have access to the raw simulation data, it is necessary to install additional software package into your VSC account.</p>
            <span class="title">Prerequesites</span>
            <ol class="my-2">
              <li>
                Obtain a VSC account at
                <a href="https://www.vscentrum.be/">https://www.vscentrum.be/</a> if you don't have it already
              </li>
            </ol>
            <span class="title">Installation of EUHFORIA Online scheduler</span>
            <ol class="my-2">
              <li>
                Generate the secret code in your EUHFORIA Online
                <router-link :to="{name: 'settings'}">settings</router-link>
              </li>
              <li>
                Login to Genius or ThinKing
                <pre>$ ssh your-vsc-username@login1-tier2.hpc.kuleuven.be</pre>or
                <pre>$ ssh your-vsc-username@login7-tier2.hpc.kuleuven.be</pre>
              </li>
              <li>
                Install supporting package for EUHFORIA Online
                <pre>$ module purge</pre>
                <pre>$ module load Python/3.7.0-foss-2018a</pre>
                <pre>$ pip install --upgrade --user git+https://isavnin@bitbucket.org/raysofspace/euhforia-app-utils.git</pre>
              </li>
              <li>
                Save the secret key as environmental variable
                <pre>$ echo "export EUHFORIAONLINE_SECRET_KEY=you-secret-key" >> ~/.bashrc</pre>
              </li>
              <li>
                If you would like to store the raw simulation data, add another environmental variable
                <pre>$ echo "export EUHFORIAONLINE_CLEAR=False" >> ~/.bashrc</pre>
              </li>
            </ol>
            <p>From time to time new versions of scheduler will be released. You will have to take care of keeping it up to date. To update the scheduler to the latest version, please, repeat the steps 2-3.</p>
            <span class="title">Accessing raw simulation data</span>
            <p>
              The raw simulation data for your runs will be available in
              <code>$VSC_SCRATCH/euhforiaonline</code> folder. You can access it from both Genius.
              Please, note that you have to make sure that there is enough space in your
              <code>$VSC_SCRATCH</code> folder. If there is not enough space the runs will start failing. Therefore, remove the data you don't need anymore or ask VSC to increase your data quota.
            </p>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogHelp: false,
      chapters: [false, false, false, false],
      menu: true,
    };
  },
  methods: {
    showMenu() {
      this.chapters.fill(false);
      this.menu = true;
    },
    showChapter(i) {
      this.menu = false;
      this.chapters.fill(false);
      this.chapters[i] = true;
    },
  },
};
</script>
